import * as Service from './Service';

export const doGet = (endpoint, body, config) => {
  return Service.axiosGet({
    body,
    endpoint,
    config,
  });
};

export const doPost = (endpoint, body, config) => {
  return Service.axiosPost({
    body,
    endpoint,
    config,
  });
};

export const doPut = (endpoint, body, config) => {
  return Service.axiosPut({
    body,
    endpoint,
    config,
  });
};

export const doDelete = (endpoint, body, config) => {
  return Service.axiosDelete({
    body,
    endpoint,
    config,
  });
};
